

/* Protopia Ecosystem component */
export interface IPanelShifterProps {
   
}
const PanelShifter = (props: IPanelShifterProps): JSX.Element => {
    return <div className='pe-panel-shifter' > 
    </div>
}
export default PanelShifter